<template>
  <div :style="cssVars">
    <page-layout
      :noSideBar="false"
      :headerBackgroundColor="cssVars['--outcome-primary']"
    >
      <template v-slot:headerContent>
        <div class="row items-center">
          <span
            :style="`color: ${cssVars['--outcome-secondary']}`"
            class="title"
          >
            {{
              currentUserData.sustainabilityBusiness_name
                ? currentUserData.sustainabilityBusiness_name
                : "Test Business"
            }}
          </span>
        </div>
        <div class="row items-center" style="position: relative">
          <span class="headerText text-white">
            {{
              selectedOutcome
                ? "Story Assessment Tool for"
                : "You need to select an outcome first"
            }}
          </span>
          <sustainability-dropdown
            :model="outcome"
            class="q-ml-sm"
            :style="`width: 230px;
                      background-color: ${
                        selectedOutcome
                          ? cssVars['--outcome-secondary']
                          : 'rgba(0,0, 0, 0.3)'
                      };
                      border-radius: 5px;
                      `"
            :options="outcomesList"
            :isObjects="true"
            objectKey="label"
            disable
          ></sustainability-dropdown>

          <q-img
            class="float-right"
            :src="getWhiteOutcomeImage(selectedOutcome)"
            style="position: absolute; right: 15px; width: 69px; top: -20px"
          ></q-img>
        </div>
      </template>
      <template v-slot:content>
        <div class="column q-pa-sm">
          <q-scroll-area
            class="col-auto"
            style="height: calc(100vh - 242px)"
            :thumb-style="{
              background: '#162c479c',
              opacity: 1,
              width: '8px',
              height: '8px',
              borderRadius: '20px',
            }"
          >
            <div class="row wrap">
              <div class="col-12">
                <h3 class="storyBoardHeader q-my-xs">
                  What have you done "to date" for {{ selectedOutcome.label }}
                </h3>
              </div>
              <div class="q-pa-xs">
                <q-card @click="newStoryCard()" class="bg-grey-3 storyCard">
                  <p
                    style="font-weight: 900; font-size: 100px"
                    class="text-accent text-center absolute-center q-my-none"
                  >
                    +
                  </p>
                </q-card>
              </div>
              <div
                class="q-pa-xs"
                v-for="(storyCard, index) in storyCards"
                :key="`storyCards_${index}`"
                @click="openStoryCard(storyCard.id)"
              >
                <storyCard :flat="false" :greyBG="true" :data="storyCard" />
              </div>
            </div>
          </q-scroll-area>
          <div class="col q-px-sm q-pt-sm">
            <q-btn
              class="q-px-sm q-py-xs bg-secondary"
              label="Back to Assessment Tool Selection"
              text-color="white"
              no-caps
              flat
              @click="goToAssessmentToolSelection"
            >
            </q-btn>
          </div>
        </div>
      </template>
      <template v-slot:sideBarContent>
        <!-- Wrapping only one DOM element, defined by QBtn -->
        <div class="column full-height full-width sidebar">
          <div class="col-auto q-py-md q-px-lg" style="height: calc(109px)">
            <div class="row full-height items-center">
              <h3>What could I write about?</h3>
            </div>
          </div>

          <div class="col-auto q-px-md" style="height: calc(100vh - 226px)">
            <q-scroll-area
              style="height: calc(100vh - 226px)"
              :thumb-style="{
                background: '#162c479c',
                opacity: 1,
                width: '8px',
                height: '8px',
                borderRadius: '20px',
              }"
            >
              <h4 class="q-my-xs" style="font-size: 1rem">
                {{ outcome.label }}
              </h4>
              <div v-html="outcome.storyBoardWhatIs"></div>
            </q-scroll-area>
          </div>
          <div class="col q-px-md">
            <q-btn
              label="Create Story"
              no-caps
              flat
              class="text-white bg-primary q-px-sm q-py-xs"
              @click="newStoryCard()"
            >
            </q-btn>
            <q-btn
              label="Review Summary"
              no-caps
              flat
              class="text-white float-right q-px-sm q-py-xs"
              :style="`background: ${cssVars['--outcome-secondary']}`"
              @click="goToStorySummary()"
            >
            </q-btn>
          </div>
        </div>
      </template>
    </page-layout>
    <q-dialog
      v-if="$route.params.storyCard_id"
      v-model="storyCardDialog"
      persistent
      max-width="90vw"
    >
      <story-card-form @reloadData="loadData" ref="storyCard"></story-card-form>
    </q-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageLayout from "@/components/pageLayout/pageLayout.vue";
import SustainabilityDropdown from "@/components/sustainabilityDropdown/sustainabilityDropdown.vue";
import storyCardForm from "@/components/storyCards/storyCardForm.vue";
import storyCard from "@/components/storyCards/storyCard.vue";
import { getWhiteOutcomeImage } from "@/functions/getWhiteOutcomeImage";

import { getCSSVars } from "@/functions/cssVars";

export default {
  components: {
    PageLayout,
    SustainabilityDropdown,
    storyCardForm,
    storyCard,
  },
  computed: {
    ...mapGetters({
      outcomesList: "outcomes/list",
      currentUserData: "auth/currentUserData",
      selectedOutcome: "businessOutcomePlans/selectedOutcome",
      storyCards: "storyCard/list",
      storyCardsLoading: "storyCard/listLoading",
    }),
    cssVars() {
      let outcome = this.selectedOutcome;
      return getCSSVars(outcome);
    },
  },
  data: () => ({
    outcome: null,
    selectedYear: null,

    newStoryCardLoading: true,

    storyCardDialog: true,
  }),
  watch: {
    selectedOutcome: function () {
      this.initSelectedOutcome();
    },
    $route: {
      handler() {
        this.handleRoute();
      },
      props: true,
    },
  },
  async mounted() {
    if (this.selectedOutcome) {
      this.initSelectedOutcome();
    }
    this.selectedYear = this.$moment().format("YYYY");
    this.loadData();
  },
  methods: {
    getWhiteOutcomeImage: getWhiteOutcomeImage,
    getCSSVars: getCSSVars,
    initSelectedOutcome() {
      this.outcome = this.selectedOutcome;
    },
    loadData() {
      this.$store.dispatch("storyCard/loadAll", {
        outcome_id: this.$route.params.outcomesID,
      });
    },

    handleRoute() {},

    openStoryCard(id) {
      this.$router.push(
        `${this.$route.path.split("storyBoard")[0]}storyBoard/${id}`
      );
    },

    async newStoryCard() {
      this.newStoryCardLoading = true;
      this.openStoryCard("createNew");
    },

    goToAssessmentToolSelection() {
      this.$router.push(
        `${this.$route.path.split("storyBoard")[0]}chooseAssessmentTool`
      );
    },

    goToStorySummary() {
      this.$router.push(
        `${this.$route.path.split("storyBoard")[0]}storySummary`
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  h3 {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 1.3rem;
    line-height: 29px;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
    color: $accent2;
    margin: 10px 0px;
  }

  h4 {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 1.2rem;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
    color: $accent2;
    margin: 10px 0px;
  }
}

.headerText {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
}

.storyCard {
  min-height: 342px;
  min-width: 260px;
  max-height: 342px;
  max-width: 260px;
  cursor: pointer;
  transition: box-shadow 250ms;

  &:hover {
    box-shadow: 0px 0px 15px 0px #c4c4c4 !important;
  }
}

.storyBoardHeader {
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.2rem;
}
</style>
